import './BaseStyles-b89ff312.css';

var classes = {"focus-visible":"prc-src-focus-visible-vqyE9","BaseStyles":"prc-src-BaseStyles-dl-St"};

export { classes as default };
